import { resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-9eeef8c4"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "search"
};
const _hoisted_2 = {
  class: "searchTop"
};
const _hoisted_3 = {
  class: "bottom"
};
const _hoisted_4 = {
  class: "searchHistory"
};
const _hoisted_5 = {
  class: "historyTop"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "历史", -1));

const _hoisted_7 = {
  class: "historyContent"
};
const _hoisted_8 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");

  const _component_van_search = _resolveComponent("van-search");

  const _component_SongList = _resolveComponent("SongList");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_icon, {
    name: "arrow-left",
    size: "25",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.go(-1))
  }), _createVNode(_component_van_search, {
    modelValue: $data.searchKey,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.searchKey = $event),
    modelModifiers: {
      lazy: true
    },
    placeholder: "IU李知恩",
    autofocus: true,
    shape: "round",
    clearable: true,
    onKeydown: _withKeys($options.saveHistory, ["enter"])
  }, null, 8, ["modelValue", "onKeydown"]), _createElementVNode("span", {
    onClick: _cache[2] || (_cache[2] = (...args) => $options.saveHistory && $options.saveHistory(...args))
  }, "搜索")]), _createElementVNode("div", _hoisted_3, [_withDirectives(_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createVNode(_component_van_icon, {
    name: "delete-o",
    size: "20",
    onClick: $options.deleteHistory
  }, null, 8, ["onClick"])]), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.keywordsList, item => {
    return _openBlock(), _createElementBlock("span", {
      class: "spankey",
      key: item,
      onClick: $event => $options.searchHistory(item)
    }, _toDisplayString(item), 9, _hoisted_8);
  }), 128))])], 512), [[_vShow, !$data.keywordsList.length == 0]]), _createVNode(_component_SongList, {
    searchSongList: $data.searchSongList
  }, null, 8, ["searchSongList"])])]);
}